import { createMerge } from './lib/create-merge.mjs';
export { createMerge } from './lib/create-merge.mjs';
import { tailwind } from './tailwind.mjs';
export { tailwind } from './tailwind.mjs';
export { arbitraryRule, cardinalRule, cardinalRules, conflictRule, simpleRule, uniqueRule } from './rules.mjs';

var twMerge = /*#__PURE__*/createMerge( /*#__PURE__*/tailwind());

export { twMerge };
//# sourceMappingURL=tw-merge.mjs.map
